angular.module("persons_reports")

    .controller("PersonsReportsCtrl", ['$scope', '$rootScope', '$controller', '$state', 'Restangular', '$uibModal', 'modalService', '$filter', 'uiGridConstants', '$q', '$http', 'logService',
        function ($scope, $rootScope, $controller, $state, Restangular, $uibModal, modalService, $filter, uiGridConstants, $q, $http, logService) {

            $rootScope.title = $filter('translate')('persons_reports.title');

            $scope.persons_reports = {
                group: {},
                state: "",
                tlf: false,
                address: false,
                contact: false,
                historic_positions: false,
                position: false
            };

            $scope.showPersonsReport = false;

            Restangular.all('PersonsAddress').customGET().then(function (states) {                
                $scope.selectStates = states;
                $scope.selectStates.unshift($filter('translate')('persons_reports.all'));
                $scope.persons_reports.state = $scope.selectStates[0];
            });

            $scope.groupTree = function (groups, locationListResult, parent_id, levelString) {

                for (var i = 0; i < groups.length; i++) {

                    if (groups[i].parent_group_id == parent_id) {
                        groups[i].name = levelString + groups[i].name;
                        locationListResult.push(groups[i]);
                        $scope.groupTree(groups, locationListResult, groups[i].id, levelString + "----");
                    }
                }
            };

            Restangular.all('Groups/GetGroupsPositions').getList().then(function (groups) {
                var groupsListResult = [];
                for (var i = 0; i < groups.length; i++) {
                    if (groups[i].parent_group_id == null) {
                        groupsListResult.push(groups[i]);
                        $scope.groupTree(groups, groupsListResult, groups[i].id, "----");
                    }
                }
                $scope.selectGroups = groupsListResult;
                $scope.selectGroups.unshift({ id: null, name: $filter('translate')('persons_reports.all') });
                $scope.persons_reports.group = $scope.selectGroups[0];
            });
            
            $scope.generateReport = function () {

                $scope.showPersonsReport = true;


                if (angular.isDefined($scope.gridOptionsPersons)) {

                    angular.forEach($scope.gridOptionsPersons.gridApi.grid.columns, function (item) {
                        logService.debug(item);
                        if (item.name === "address") {
                            if ($scope.persons_reports.address) {
                                item.showColumn();
                                logService.debug(item);
                            } else {
                                item.hideColumn();
                            }
                        } 
                        if (item.name === "group") {
                            if ($scope.persons_reports.position) {
                                item.showColumn();
                            } else {
                                item.hideColumn();
                            }
                        }
                        if (item.name === "position") {
                            if ($scope.persons_reports.position) {
                                item.showColumn();
                            } else {
                                item.hideColumn();
                            }
                        }
                        if (item.name === "contact") {
                            if ($scope.persons_reports.contact) {
                                item.showColumn();
                            } else {
                                item.hideColumn();
                            }
                        }
                    });
                    $scope.gridOptionsPersons.gridApi.core.refresh();
                    $scope.gridOptionsPersons.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                    $scope.gridOptionsPersons.loadData(false);
                } else {
                    $scope.gridOptionsPersons = {
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        enableHiding: false,
                        gridMenuShowHideColumns: true,
                        paginationPageSizes: [15, 30, 45],
                        paginationPageSize: 15,
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        pdfTitle: $filter('translate')('persons_reports.pdf_title'),
                        getFilterExternalDescription: function () {
                            var externalFilters = "";
                            if (angular.isDefined($scope.persons_reports.group) && $scope.persons_reports.group.id != null)
                                externalFilters += $filter('translate')('persons_reports.group') + ": " + $scope.persons_reports.group.name.replace("----", "") + "\n";
                            if ($scope.persons_reports.state !== "" && $scope.persons_reports.state !== $filter('translate')('persons_reports.all'))
                                externalFilters += $filter('translate')('persons_reports.state') + ": " + $scope.persons_reports.state + "\n";
                            return externalFilters;
                        },
                        columnDefs: [
                            { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                            {
                                field: 'image_small', enableSorting: false, visible: true, 
                                customFormatFn: function (value) {
                                    if (value != null) {                                        
                                        var img = {
                                            image: value,
                                            width: 30
                                        };
                                        return img;
                                    } else {
                                        return "";
                                    }
                                },
                                displayName: $filter('translate')('persons_reports.photo'), cellTemplate: "<img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\"  ng-src=\"{{grid.getCellValue(row, col)}}\" style=\"margin-left:10px;margin-top:1px\" lazy-src>", width: 70, enableFiltering: false

                            },
                            { name: 'name', displayName: $filter('translate')('persons_reports.name'), enableHiding: false, enableGridMenu: false },
                            { name: 'surname', displayName: $filter('translate')('persons_reports.surname'), enableGridMenu: false },
                            { name: 'lastname', displayName: $filter('translate')('persons_reports.lastname'), enableGridMenu: false },
                            { field: 'address', name: 'address', displayName: $filter('translate')('persons_reports.address'), enableGridMenu: false, visible: $scope.persons_reports.address},
                            { field: 'contact', name: 'contact', displayName: $filter('translate')('persons_reports.contact'), enableGridMenu: false, visible: $scope.persons_reports.contact },
                            { field: 'position_name', name: 'position', displayName: $filter('translate')('persons_reports.position'), enableGridMenu: false, visible: $scope.persons_reports.position },
                            { field: 'group_name', name: 'group', displayName: $filter('translate')('persons_reports.group_name'), enableGridMenu: false, visible: $scope.persons_reports.position }
                        ],
                        getData: function (options) {
                            if ($scope.persons_reports.state !== "" && $scope.persons_reports.state !== $filter('translate')('persons_reports.all'))
                                options.state = $scope.persons_reports.state;
                            options.group_id = $scope.persons_reports.group.id;
                            options.showAddress = $scope.persons_reports.address;
                            options.showPositions = $scope.persons_reports.position;
                            options.showContact = $scope.persons_reports.contact;
                            options.showHistoric = $scope.persons_reports.historic_positions;

                            var deferred = $q.defer();
                            Restangular.all('Reports/Authorities').getList(options).then(function (results, status, headers, config) {
                                var data = results;
                                var personsIds = [];
                                angular.forEach(data, function (dataR) {
                                    if (personsIds.indexOf(dataR.id) < 0) {
                                        personsIds.push(dataR.id);
                                    }
                                });
                                //Obtenemos sus imágenes
                                if (personsIds.length > 0) {
                                    $http({
                                        method: 'post',
                                        url: (window as any).CONFIG.api_url + 'Persons/ImagesSmall',
                                        params: { ids: personsIds }
                                    }).then(function (resultsImage, status, headers, config) {
                                        angular.forEach(data, function (person) {
                                            for (var i = 0; i < resultsImage.data.length; i++) {
                                                if (person.id == resultsImage.data[i].person_id) {
                                                    person.image_small = resultsImage.data[i].image_small;
                                                    break;
                                                }
                                            }
                                        });
                                    });
                                }
                                data.totalRows = results.totalRows;
                                $scope.totalRows = results.totalRows;
                                deferred.resolve(data);
                            });
                            return deferred.promise;
                        }

                    };
                }
            };

        }])


.filter('getNames', function () {
    return function (items) {        
        return items && items.map(function (item) {
            return item.FK_events_tasks_users_users.name;
        }).join(', ');
    }
})

;